var map = {
	"./en/experiences.json": "e204",
	"./en/fields.json": "e417",
	"./en/home.json": "f6f3",
	"./en/legalTexts.json": "e8f4",
	"./en/menus.json": "2ba6",
	"./en/placeholders.json": "8ced",
	"./en/validations.json": "cec9",
	"./en/villas.json": "f858",
	"./es/experiences.json": "a27b",
	"./es/fields.json": "a574",
	"./es/home.json": "3d4d",
	"./es/legalTexts.json": "0890",
	"./es/menus.json": "0a7b",
	"./es/placeholders.json": "f0e9",
	"./es/validations.json": "0e1d",
	"./es/villas.json": "64f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";